import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
// const CONDITION_API = "/accounts/conditions/";

export const getSSOURL = (params) => {
  return axios.get("/accounts/sso_url/").then(res => {
    return res.data;
  });
}

export const getUserInfo = (params) => {
  return axios.get("/accounts/user-info/", {
      headers: {
        "Authorization": `Bearer ${getCookie('access')}`
      }
    })
}